
import { motion } from "framer-motion";

export default function ScrollAnimation({ id, className, children, ariaLabelledBy }) {
  return (
    <motion.section
      id={id}
      className={className}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: false }}
      aria-labelledby={ariaLabelledBy}
    >
      {children}
    </motion.section>
  );
}
